<section>
    <header class="header-modal">
        <h3>{{modalTitle}}</h3>
        <button type="button" mat-icon-button (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <div class="content-modal">
        <form [formGroup]="createUpdateDocTypeFormGroup" (ngSubmit)="submit()">
            <div class="main-inputs">
                <mat-form-field class="input-name">
                    <mat-label>Nombre</mat-label>
                    <input matInput formControlName="name"/>
                </mat-form-field>
                <mat-form-field class="input-description">
                    <mat-label>Descripción</mat-label>
                    <textarea formControlName="description" matInput cdkTextareaAutosize></textarea>
                </mat-form-field>
            </div>
            <div class="separator">
                <span>Otros campos</span>
            </div>
            <ng-container formArrayName="customFields">
                <ng-container *ngFor="let customFieldForm of customFields.controls; let i = index">
                    <div [formGroupName]="i">
                        <mat-card>
                            <mat-card-content class="custom-field-card">
                                <div class="inner-custom-field">
                                    <mat-form-field>
                                        <mat-label>Nombre</mat-label>
                                        <input matInput formControlName="fieldName">
                                        <mat-error *ngIf="customFieldForm.get('fieldName')?.invalid">
                                            <span *ngIf="customFieldForm.get('fieldName')?.hasError('required')">
                                                Requerido
                                            </span>
                                        </mat-error>
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Tipo</mat-label>
                                        <mat-select formControlName="typeField">
                                            <mat-option *ngFor="let type of availableTypes" [value]="type.value">
                                                {{type.text}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-checkbox formControlName="required">Obligatorio</mat-checkbox>
                                </div>
                                <div class="inner-custom-field-action">
                                    <button type="button" (click)="removeCustomField(i)" mat-mini-fab color="warn">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </ng-container>
            </ng-container>
            <div class="form-add-field-section">
                <button type="button" color="primary" (click)="addCustomField()" mat-stroked-button>Nuevo campo</button>
            </div>
            <div class="botton-form-action">
                <button [disabled]="createUpdateDocTypeFormGroup.invalid" type="submit" mat-raised-button color="primary">{{submitText}}</button>
            </div>
        </form>
    </div>
</section>